
import LearnContent from "./learn/LearnContent";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import { useEffect } from "react";
import { Toaster } from "sonner";

const Learn = () => {
  // Set page title
  useEffect(() => {
    document.title = "ML System Design Resources | HelloML";
  }, []);

  return (
    <div className="flex flex-col min-h-screen">
      <Navbar />
      <LearnContent />
      <Footer />
      <Toaster position="bottom-right" />
    </div>
  );
};

export default Learn;
